export enum LogEntityClass {
  CERTIFICATE = "certificate",
  CREATE_OPTION = "creation_option",
  DEVICE = "device",
  GATEWAY = "gateway",
  GROUP = "group",
  INTERFACE = "interface",
  INTERFACE_MQTT = "interface_mqtt",
  PKI = "pki_config",
  PLATFORM = "platform",
  ROLE = "role",
  SECTOR = "sector",
  TRUSTCHAIN = "trustchain",
  USER = "user",
}
